import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

// ── Find & replace ────────────────────────────────────────────────────
export function FindReplaceInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Find</FieldLabel>
      <TextInput mono value={c.find || ''} onChange={(v) => u({ find: v })} placeholder="text to find" />
      <FieldLabel>Replace with</FieldLabel>
      <TextInput mono value={c.replace ?? ''} onChange={(v) => u({ replace: v })} placeholder="replacement text" />
      <FieldLabel>Case sensitivity</FieldLabel>
      <Segmented
        value={c.caseSensitive === false ? 'no' : 'yes'}
        onChange={(v) => u({ caseSensitive: v === 'yes' })}
        options={[
          { value: 'yes', label: 'Case-sensitive' },
          { value: 'no', label: 'Ignore case' },
        ]}
      />
    </div>
  );
}


// ── Feature Engineering / Scaling ─────────────────────────────────────
// All scaling inspectors:
//   • Use <MultiCols numeric /> so only number-typed columns are shown.
//     Column types come from live row inference (currency strings count).
//   • onChange writes both `columns` (array) and `column` (first item,
//     legacy compat) so the backend receives a consistent config shape.
//   • The backend always creates a NEW column  <col>_scaled  per selected
//     column; the original column is never overwritten. The preview schema
//     must include those new keys (see columnsFromRows in App.jsx).
